import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useToastOptionContext } from "./chunk-ZP4IHIHZ.mjs";
import { createToastFn } from "./chunk-RANSABEB.mjs";

// src/use-toast.tsx
import { useChakra } from "@chakra-ui/system";
import { useMemo } from "react";
function useToast(options) {
  var _useChakra = useChakra(),
    theme = _useChakra.theme;
  var defaultOptions = useToastOptionContext();
  return useMemo(function () {
    return createToastFn(theme.direction, _objectSpread(_objectSpread({}, defaultOptions), options));
  }, [options, theme.direction, defaultOptions]);
}
var use_toast_default = useToast;
export { useToast, use_toast_default };